(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teaser"] && !Shopify.designMode) return;
  try {
    ;(() => {
    if (window.__globalTeaserInitialized) return
    window.__globalTeaserInitialized = true

    const rootSelector = '[data-teaser-root]'
    const closeSelector = '[data-teaser-close]'
    const triggerSelector = '[data-teaser-trigger]'
    const closingDuration = 300
    const initialDisplayDelay = 2000

    let klaviyoFormOpen = false

    const safeSessionGet = (key) => {
      try {
        return window.sessionStorage.getItem(key)
      } catch (_error) {
        return null
      }
    }

    const safeSessionSet = (key, value) => {
      try {
        window.sessionStorage.setItem(key, value)
      } catch (_error) {
        // Storage can be unavailable in private browsing modes.
      }
    }

    const getTrackingPayload = (trigger, status) => ({
      sectionId: trigger.dataset.sectionId || '',
      behavior: 'trigger_klaviyo',
      formId: trigger.dataset.klaviyoFormId || '',
      ctaLabel: trigger.dataset.ctaLabel || '',
      status,
    })

    const track = (trigger, status) => {
      const eventName = trigger.dataset.trackingEvent
      if (!eventName) return

      const detail = getTrackingPayload(trigger, status)
      window.dispatchEvent(new CustomEvent(eventName, { detail }))

      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, detail)
      }
    }

    const navigateFallback = (url) => {
      if (!url) return
      window.location.href = url
    }

    const openKlaviyoForm = (formId, fallbackUrl) => {
      if (!formId) return false

      try {
        if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
          const result = window.klaviyo.openForm(formId)

          if (result && typeof result.catch === 'function') {
            result.catch(() => navigateFallback(fallbackUrl))
          }

          return result !== false
        }
      } catch (_error) {
        return false
      }

      try {
        if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
          const result = window._klOnsite.openForm([formId])
          return result !== false
        }
      } catch (_error) {
        return false
      }

      return false
    }

    const getDisplayTiming = (root) => root.dataset.displayTiming || 'show_before_form'

    const showsBeforeForm = (timing) => timing !== 'show_after_form_close'

    const showsAfterFormClose = (timing) =>
      timing === 'show_after_form_close' || timing === 'show_before_and_after_form'

    const isDismissed = (root) => {
      const storageKey = root.dataset.storageKey
      return Boolean(storageKey && safeSessionGet(storageKey) === 'true')
    }

    const showTeaser = (root) => {
      if (!root || root.hidden) return
      if (root.dataset.state === 'open' || root.dataset.state === 'closing') return

      window.requestAnimationFrame(() => {
        root.dataset.state = 'open'
      })
    }

    // Slides the teaser offscreen while a Klaviyo form is open, without
    // recording a dismissal, so it can come back after the form closes.
    const retractTeaser = (root) => {
      if (!root || root.dataset.state !== 'open') return
      root.dataset.state = 'initial'
    }

    const initTeasers = () => {
      document.querySelectorAll(rootSelector).forEach((root) => {
        if (isDismissed(root)) {
          root.hidden = true
          root.dataset.state = 'hidden'
          return
        }

        if (showsBeforeForm(getDisplayTiming(root))) {
          window.setTimeout(() => {
            if (!klaviyoFormOpen) showTeaser(root)
          }, initialDisplayDelay)
        }
      })
    }

    const handleKlaviyoFormEvent = (event) => {
      const type = event.detail && event.detail.type
      if (type !== 'open' && type !== 'close') return

      klaviyoFormOpen = type === 'open'

      document.querySelectorAll(rootSelector).forEach((root) => {
        if (type === 'open') {
          retractTeaser(root)
          return
        }

        const isMobileViewport = window.matchMedia('(max-width: 767px)').matches
        if (showsAfterFormClose(getDisplayTiming(root)) && !isMobileViewport) {
          showTeaser(root)
        }
      })
    }

    const dismissTeaser = (root) => {
      if (!root || root.dataset.state === 'closing') return

      root.dataset.state = 'closing'

      let isComplete = false

      const finish = () => {
        if (isComplete) return
        isComplete = true
        root.removeEventListener('transitionend', onTransitionEnd)

        if (root.dataset.storageKey) {
          safeSessionSet(root.dataset.storageKey, 'true')
        }

        root.hidden = true
        root.dataset.state = 'hidden'
      }

      const onTransitionEnd = (event) => {
        if (event.target !== root) return
        if (event.propertyName !== 'transform' && event.propertyName !== 'opacity') return
        finish()
      }

      root.addEventListener('transitionend', onTransitionEnd)
      window.setTimeout(finish, closingDuration)
    }

    const handleClick = (event) => {
      const target = event.target
      if (!(target instanceof Element)) return

      const close = target.closest(closeSelector)
      if (close) {
        event.preventDefault()
        event.stopPropagation()
        dismissTeaser(close.closest(rootSelector))
        return
      }

      const trigger = target.closest(triggerSelector)
      if (!trigger) return

      event.preventDefault()

      const root = trigger.closest(rootSelector)
      const formId = trigger.dataset.klaviyoFormId || ''
      const fallbackUrl = trigger.dataset.fallbackUrl || ''

      if (root) root.removeAttribute('data-status')

      track(trigger, 'click')

      if (openKlaviyoForm(formId, fallbackUrl)) {
        track(trigger, 'opened')
        return
      }

      if (root) root.dataset.status = 'error'

      track(trigger, fallbackUrl ? 'fallback' : 'unavailable')
      navigateFallback(fallbackUrl)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTeasers, { once: true })
    } else {
      initTeasers()
    }

    window.addEventListener('klaviyoForms', handleKlaviyoFormEvent)
    document.addEventListener('click', handleClick)
  })()
  } catch(e) { console.error(e); }
})();

})();
